import { isEqual } from "lodash";

import { useMemo } from "react";

import { TimePoints, TimePointsLabel } from "@/constants/timeRange";
import { getOptionCheckedText, getRadioCheckedText } from "@/utils/filter";

import { lastTimeOptions } from "../../../../Routes/components/FilterBar/utils/constants";
import { useFilterContext } from "../FilterContext";
import { getFilterConfigByKey } from "../filters";
import { FilterData } from "../typing";

/**
 * 用于回显选中的filterButton
 * @returns
 */
const useFilterChecked = () => {
  const { filterData, filterOptions, defaultFilterData } = useFilterContext();
  return useMemo(() => {
    const filterCheckedMap: Record<string, string> = {};

    const isDefault = (key: keyof FilterData) => {
      return isEqual(defaultFilterData[key], filterData[key]);
    };

    const filterOptionsMap = {
      programs: filterOptions.programsOptions,
      stops: filterOptions.stopsOptions,
      banks: filterOptions.banksOptions,
    };

    for (const key of Object.keys(filterData)) {
      switch (key) {
        case "banks":
        case "programs": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getOptionCheckedText(filterOptionsMap[key], filterData[key]);
          break;
        }

        case "stops": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getRadioCheckedText(filterOptionsMap[key], filterData[key]);
          break;
        }

        case "tax":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: $${filterData[key]}`;
          break;

        case "seats":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${filterData[key]}`;
          break;

        case "maxPoints":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${filterData[key] / 1000}K`;
          break;

        case "duration":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${filterData[key]} hours`;
          break;

        case "premium":
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : `${key}: ${filterData[key][0]}%-${filterData[key][1]}%`;
          break;

        case "lastSeenTime":
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getRadioCheckedText(lastTimeOptions, filterData[key]);
          break;

        case "departureTimeRange":
        case "arrivalTimeRange": {
          const conf = getFilterConfigByKey(key);
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : `${conf?.label}: ${TimePointsLabel[TimePoints[filterData[key][0]]]}-${
                TimePointsLabel[TimePoints[filterData[key][1]]]
              }`;
          break;
        }

        case "times": {
          const res = [
            [filterData[key][0], filterData[key][1]],
            [filterData[key][2], filterData[key][3]],
          ]
            .map((v, i) => {
              if (v[0] === 0 && v[1] === 24) {
                return "";
              }
              return "Times";
            })
            .filter(Boolean);
          const d = res.length > 1 ? `${res[0]} +${res.length - 1}` : res[0];
          filterCheckedMap[key] = isDefault(key) ? "" : d;
          break;
        }

        default:
          break;
      }
    }

    return filterCheckedMap;
  }, [filterData, filterOptions, defaultFilterData]);
};

export default useFilterChecked;
